module.exports = __webpack_public_path__ + "img/1.e411ba8c.jpg";